var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00390625,
    width: 60,
    height: 60,
    rx: 4,
    fill: "#012F59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1992 31.0954C24.1992 31.4087 24.4416 31.6509 24.7964 31.6509H30.2072L27.3413 39.3359C27.0154 40.2117 27.9171 40.6674 28.4958 39.9591L37.1174 29.2707C37.2612 29.0791 37.3472 28.9155 37.3472 28.7157C37.3472 28.4024 37.1094 28.1602 36.75 28.1602H31.3354L34.2051 20.4751C34.5356 19.5994 33.6255 19.1436 33.0468 19.8519L24.429 30.5404C24.2852 30.7319 24.1992 30.8956 24.1992 31.0954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOnIcon);
export default __webpack_public_path__ + "static/media/power-on-icon.f19e3b13d040212d2247589cc0f0dc14.svg";
export { ForwardRef as ReactComponent };